const common = {
  "nav.home": "Home",
  "nav.categories": "Categories",
  "nav.guide": "Guide",
  "nav.faq": "FAQ",
  "hero.title": "OOPBuy Spreadsheet",
  "hero.subtitle": "Updated Product Database, Guide & Verified Lists 2026",
  "hero.description": "The OOPBuy spreadsheet is a structured and regularly updated product sourcing database designed to help you quickly find verified product lists, compare alternatives, and access organized data for smarter decision-making.",
  "hero.cta.primary": "Access OOPBuy Spreadsheet",
  "hero.cta.secondary": "Buy It Now",
  "hero.hook": "The OOPBuy spreadsheet is an online structured database that organizes product sourcing information into categorized spreadsheets. It helps users access updated product lists, compare alternatives, and track sourcing data efficiently in one system.",
  "categories.title": "Browse Product Categories",
  "categories.subtitle": "Quick Access",
  "categories.description": "Explore all available product categories in the OOPBuy spreadsheet database. Each category contains verified and regularly updated listings.",
  "about.label": "/ OOPBuy Guide",
  "about.title": "What is OOPBuy Spreadsheet?",
  "about.p1": "The OOPBuy spreadsheet is a digital product sourcing system that organizes listings, supplier data, and product comparisons into a structured spreadsheet format. It serves as a centralized hub for anyone looking to navigate the complex world of product sourcing with confidence and clarity.",
  "about.p2": "Whether you are searching for shoes, hoodies, jackets, or accessories, the OOPBuy spreadsheet categorizes everything into easily navigable sections, saving you hours of manual research. Each listing is organized with key details that help you compare options and make informed decisions quickly.",
  "about.p3": "In simple terms, the OOPBuy spreadsheet is a centralized product intelligence system that brings together verified product information from multiple sources into one cohesive, easy-to-use format.",
  "about.trust.label": "• Verified Data Source",
  "about.trust.text": "Trusted by thousands of users worldwide for reliable product sourcing data",
  "about.bullet1": "Finding updated product lists across multiple categories",
  "about.bullet2": "Comparing sourcing options side by side",
  "about.bullet3": "Tracking new product releases and availability",
  "about.bullet4": "Organizing supplier data systematically",
  "comparison.title": "OOPBuy Spreadsheet vs Manual Product Research",
  "comparison.oopbuy": "OOPBuy Spreadsheet",
  "comparison.manual": "Manual Research",
  "faq.title": "Frequently Asked Questions",
  "faq.subtitle": "People Also Ask",
  "faq.description": "Find answers to the most common questions about the OOPBuy spreadsheet system.",
  "cta.title": "Ready to Explore the OOPBuy Spreadsheet?",
  "cta.description": "Access the complete product database and start discovering verified listings across all categories today.",
  "cta.button": "Buy It Now",
  "articles.title": "In-Depth OOPBuy Spreadsheet Guides",
  "articles.subtitle": "SEO Guides & Articles",
  "articles.description": "Explore our collection of original, in-depth articles covering everything you need to know about the OOPBuy spreadsheet system, product sourcing strategies, and category navigation.",
  "articles.read": "Read Article",
  "articles.viewAll": "Read the Complete Guide",
  "footer.brand.desc": "Your trusted gateway to the OOPBuy spreadsheet product database. Access verified product listings, compare alternatives, and explore organized category data for smarter sourcing decisions.",
  "footer.categories": "CATEGORIES",
  "footer.guides": "GUIDES",
  "footer.legal": "LEGAL",
  "footer.guide.link": "Complete Guide",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Use",
  "footer.disclaimer": "Disclaimer",
  "footer.copyright": "© 2026 OOPBuy Spreadsheet. All rights reserved.",
  "article.link": "Read the Complete OOPBuy Spreadsheet Guide",
};

export default common;